<template>
  <!-- Not in experience editor-->
  <v-btn
    v-if="this.fields.LinkIcon && this.fields.LinkIcon.fields.IconName && this.fields.Link"
    :ripple="false"
    :class="this.fields.LinkIcon.fields.IconName.value"
    text
    :href="this.fields.Link.value.href | fixTelephoneLink"
    :target="fields.Link.value.target"
    v-on:click.native="trackAnalytics(fields)"
  >
    <v-icon left>{{ this.fields.LinkIcon.fields.IconName.value }}</v-icon>
    <span>{{ this.fields.Link.value.text }}</span>
  </v-btn>
</template>

<script>
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'HeaderLink',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        LinkIcon: null,
        Link: null,
      }),
    },
  },
  computed: {
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
  },
  methods: {
    trackAnalytics(fields) {
      if (fields.Link.value.text) {
        this.$store.dispatch('analytics', {
          actionName: 'Custom-Link-Click',
          entityChange: fields.Link.value.text,
        });
      }
    },
  },
};
</script>
